/**
 * Keeper API.
 *
 * **One door, as the server has one.** `apps.keeper.service.ask` is the only way into the
 * model on the server because the rules live at that door; a second way in from the client
 * would be a way past them.
 *
 * Nothing here ever publishes. What comes back is an answer to read, or a sentence saying
 * Keeper could not answer — and the second is a perfectly good outcome. A family's archive
 * does not depend on somebody else's uptime.
 */

import { api } from './client.js';

/** The opening line and the chips, before anybody types. */
export async function keeperOpening() {
  return api.get('/keeper/ask/');
}

export async function askKeeper(question) {
  return api.post('/keeper/ask/', { question });
}
